import { GameType } from "@apiserver-rest/ponder-data-client-base";

/**
 * Essentially the game table but without having to hit the database.
 * todo something to keep this in sync.
 */
export class GameInfo {
    public constructor(
        public id: number, 
        public name: string, 
        public shortName: string,
        public uriName: string) {

    }
}

export function gameTypeToGameInfo(game: GameType): GameInfo | undefined {
    switch (game) {
        case GameType.Magic:
            return new GameInfo(gameTypeToId(game), "Magic: The Gathering", "Magic", "magic");

        case GameType.Pokemon:
            return new GameInfo(gameTypeToId(game), "Pokémon Trading Card Game", "Pokémon", "pokemon");

        case GameType.Yugioh:
            return new GameInfo(gameTypeToId(game), "Yu-Gi-Oh! Trading Card Game", "Yu-Gi-Oh!", "yugioh");

        case GameType.Lorcana:
            return new GameInfo(gameTypeToId(game), "Disney Lorcana", "Lorcana", "lorcana");

        default:
            return undefined;
    }
}

export function gameTypeToId(game: GameType): number {
    switch (game) {
        case GameType.None:
        default:
            return 0;

        case GameType.Magic:
            return 1;

        case GameType.Pokemon:
            return 2;

        case GameType.Yugioh:
            return 3;

        case GameType.Lorcana:
            return 4;
    }
}

export function getAllGames(): GameInfo[] {
    var allGames: GameInfo[] = [
        gameTypeToGameInfo(GameType.Magic)!,
        gameTypeToGameInfo(GameType.Pokemon)!,
        gameTypeToGameInfo(GameType.Yugioh)!,
        gameTypeToGameInfo(GameType.Lorcana)!
    ];

    return allGames;
}